// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.divider[data-v-480f3b0d]{\n    width:5px;\n    height:auto;\n    display:inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
